import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Share as KitchenSinkShare,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const Share: React.FC<{ pageTitle?: string }> = ({ pageTitle }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <KitchenSinkShare
            title={<h4>{t('components.share.title')}</h4>}
            pageTitle={pageTitle}
            items={[
              'facebook',
              'twitter',
              'linkedin',
              'whatsapp',
              'mail',
            ]}
            withLabels
          />
        </div>
      </div>
    </Container>
  );
};

export default Share;
